import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MicIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { getRandomPlaceholder, getEncouragementMessage, categorizeRant, generateId } from '../utils/rantUtils';
import { saveRantToDatabase } from '../services/rantService';
export const RantInput: React.FC = () => {
  const [rantText, setRantText] = useState<string>('');
  const [placeholder, setPlaceholder] = useState<string>(getRandomPlaceholder());
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();
  // Change placeholder text every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholder(getRandomPlaceholder());
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (rantText.trim().length === 0) return;
    setIsSubmitting(true);
    // Create new rant object
    const newRant = {
      id: generateId(),
      text: rantText,
      category: categorizeRant(rantText),
      votes: 0,
      timestamp: Date.now()
    };
    try {
      // Save to Supabase
      await saveRantToDatabase(newRant);
      // Navigate to confirmation page
      setTimeout(() => {
        navigate('/confirmation');
      }, 500);
    } catch (error) {
      console.error('Failed to save rant:', error);
      setIsSubmitting(false);
      alert('Failed to save rant. Please try again.');
    }
  };
  const charCount = rantText.length;
  const encouragementMessage = getEncouragementMessage(charCount);
  return <div className="w-full max-w-3xl mx-auto" data-id="element-112">
      <form onSubmit={handleSubmit} className="flex flex-col" data-id="element-113">
        <div className="relative" data-id="element-114">
          <textarea value={rantText} onChange={e => setRantText(e.target.value)} placeholder={placeholder} className="w-full h-60 p-6 text-xl bg-background-light text-text-primary placeholder-text-secondary border-2 border-gray-800 rounded-lg focus:outline-none focus:border-primary transition-all resize-none" disabled={isSubmitting} data-id="element-115" />
          <div className="absolute bottom-4 left-6 flex justify-between items-center w-[calc(100%-3rem)]" data-id="element-116">
            <motion.span className="text-text-secondary text-sm" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} key={encouragementMessage} // Trigger animation when message changes
          data-id="element-117">
              {encouragementMessage}
            </motion.span>
            <span className="text-text-secondary text-sm" data-id="element-118">
              {charCount} characters
            </span>
          </div>
        </div>
        <motion.button type="submit" className="btn-primary mt-6 py-4 px-8 rounded-lg text-xl font-bold flex items-center justify-center gap-2 self-center" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} disabled={rantText.trim().length === 0 || isSubmitting} initial={{
        backgroundColor: '#FF4500'
      }} whileHover={{
        backgroundColor: '#FF6A33'
      }} data-id="element-119">
          <MicIcon className="h-6 w-6" data-id="element-120" />
          {isSubmitting ? 'SENDING...' : '🔥 DROP THE MIC'}
        </motion.button>
      </form>
    </div>;
};